//
import React from "react";
import { Link } from "react-router-dom";

import data from "../assets/data/company.json";
import "../scss/Copyright.scss";

export const Copyright = () => {
  const year = new Date();
  return (
    <div className='copyright'>
      <div>
        &copy; {data.Company_Start_Year} - {year.getFullYear()} &nbsp;
        <Link className='domain' to='https://widepack.be'>
          WidePack
        </Link>
      </div>
      <div>
        &nbsp; created by &nbsp;
        <Link className='scorpio' to='https://scorpiocoding.com'>
          ScorpioCoding.com
        </Link>
      </div>
    </div>
  );
};
